import $ from "jquery";

import Backdraft from "backdraft-app/src/backdraft";

import template from "../../templates/advertiser_campaign/form.jst";

import Config from "legacy/config";
import Application from "shared/application";

Backdraft.app("Header", function(app) {
  var Controls = Backdraft.plugin("Controls");

  app.view("NewAdvertiserCampaignForm", {

    template,

    events: {
      "change .js-custom-prompt-enabled": "_onCustomPromptClick",
      "click button.use-demo-number": "_useDemoNumber",
      "change .js-data-record-call-enabled": "_toggleRecordingForInsightsMessage"
    },

    bindings: {
      "input[data-campaign-name]": "name",
      "input[data-campaign-id-from-network]": "id_from_network",
      "input[data-destination-number]": "destination_phone_number",
      "textarea[data-custom-prompt-message]": "custom_prompt_text",
      "input[data-custom-prompt-enabled]": "play_custom_prompt",
      "input[data-record-call-enabled]": "record_calls",
      ":radio[name='campaignType']": "campaign_type"
    },

    initialize: function() {
      app.Views.NewAdvertiserCampaignForm.__super__.initialize.apply(this, arguments);

      if (!this.model) {
        throw new Error("model must be provided");
      }
    },

    render: function() {
      this.$el.html(this.template({ app, locale: Application.locale, networkName: Config.network.name }));
      var isNetwork = RegExp(/network/i).test(app.config.effectiveOrganizationType);

      if (isNetwork) {
        this._renderAdvertiserSelect();
      }

      if (!app.config.showAffiliates) {
        this.model.set({ campaign_type: this.$('[data-input="campaign-type__direct-only"]').val() });
        this.$('[data-mount="input-campaign-type__affiliate"]').remove();
      }

      this.$(".record-calls").toggle(!app.config.network.disableCallRecordings);

      if (!app.config.network.demo) {
        this.$('button.use-demo-number').remove();
      }

      this.stickit();
      return this;
    },

    _setupCallRecordingBindings: function() {
      var self = this;
      this.model.on("change:advertiser_id", function() {
        var isNetwork = RegExp(/network/i).test(app.config.effectiveOrganizationType);
        if (isNetwork) {
          var advertiserID = this.get("advertiser_id");
          if (advertiserID) {
            this.checkForInsightsOnFutureCampaigns(advertiserID);
          } else {
            this.set({ canApplyInsightsToFutureCampaigns: false });
          }
        }
      });

      this.model.on("change:canApplyInsightsToFutureCampaigns", function() {
        self._toggleRecordingForInsightsMessage();
      });
    },

    _renderAdvertiserSelect: function() {
      this.$(".advertiser-area").append($("<label>").text(app.nameForAdvertiser(false, false, false, true)));
      var advertiserSelect = new Controls.EditableSelectInputView({
        attributes: { "data-advertiser-id": true },
        attr: "advertiser_id",
        placeholder: 'Select ' + app.nameForAdvertiser(true, false, false, true) + '...',
        width: 300,
        model: this.model,
        href: app.config.urlConfig.advertiserList
      });
      this.child("advertiser-select", advertiserSelect);
      this.$(".advertiser-area").append(advertiserSelect.render().$el);
    },

    _onCustomPromptClick: function() {
      if (this.$(".js-custom-prompt-enabled").prop("checked")) {
        this.$(".js-custom-prompt-toggle").slideDown(300);
      } else {
        this.$(".js-custom-prompt-toggle").slideUp(300);
      }
    },

    _useDemoNumber : function() {
      this.model.set('destination_phone_number', app.config.invocaDemoPhoneNumber);
    }
  });
});
